module.exports = __webpack_public_path__ + "static/media/moviezhub_react.7cb94a03.png";